module.exports = function anonymous(locals, escapeFn, include, rethrow
) {
escapeFn = escapeFn || function (markup) {
  return markup == undefined
    ? ''
    : String(markup)
      .replace(_MATCH_HTML, encode_char);
};
var _ENCODE_HTML_RULES = {
      "&": "&amp;"
    , "<": "&lt;"
    , ">": "&gt;"
    , '"': "&#34;"
    , "'": "&#39;"
    }
  , _MATCH_HTML = /[&<>'"]/g;
function encode_char(c) {
  return _ENCODE_HTML_RULES[c] || c;
};
;
  var __output = [], __append = __output.push.bind(__output);
  with (locals || {}) {
    ; __append("<div class=\"table\">\n	<div>\n		<div>Ведомство</div>\n		<div>\n			<control type=\"enum-select\" target=\"parameters.department\" enum=\"Department\" show-empty/>\n		</div>\n\n		<div>Район</div>\n		<div>\n			<control type=\"data-autocomplete\" bind=\"parameters.district:code\" source=\"Kladr.Data.Districts\"\n					 column=\"name\" columns=\"name\" strict=\"strict\"/>\n		</div>\n\n		<div>С даты</div>\n		<div>\n			<control type=\"datetimepicker\" target=\"parameters.fromDateTime\"/>\n		</div>\n\n		<div>По дату</div>\n		<div>\n			<control type=\"datetimepicker\" target=\"parameters.toDateTime\"/>\n		</div>\n\n		<div>Статус</div>\n		<div>\n			<control type=\"enum-select\" target=\"parameters.department\" enum=\"Glonass.PresenceAssignmentStatus\"\n					 show-empty/>\n		</div>\n	</div>\n</div>\n\n<button on-click=\"onCreateClick\" data-format=\"")
    ; __append(escapeFn( Reports.Format.Html ))
    ; __append("\">Создать</button>\n<button on-click=\"onCreateClick\" data-format=\"")
    ; __append(escapeFn( Reports.Format.Excel ))
    ; __append("\">Создать в формате Excel</button>\n")
  }
  return __output.join("");

}